module.exports = __webpack_public_path__ + "static/media/trendex-usa-min.fc265036.png";